module.exports = "/* notifications */\n.unread mat-icon {\n  color: red; }\n"